import { fetchregulatoryInfo } from "../../../api/regulatory/regulatory.service"
import { CLEAR_REGULATORY_INFO, FETCH_REGULATORY_INFO } from "../actionTypes"

const requestListRequest = ()=>({type: FETCH_REGULATORY_INFO.REQUEST})
const requestListFailure = (error)=>({type: FETCH_REGULATORY_INFO.FAILURE, error})
const requestListSuccess = (obj)=>({type: FETCH_REGULATORY_INFO.SUCCESS, obj})
const clearRegulatoryInfo = () => ({ type: CLEAR_REGULATORY_INFO });

export const getRegulatoryinfo = (option)=>{
    return (dispatch, getState)=>{        
        dispatch(requestListRequest())
        return fetchregulatoryInfo(option)  
        .then(response => {            
            dispatch(requestListSuccess(response))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(requestListFailure(error?.message))
            return Promise.resolve({code:error?.code})
        })
    }
}

export const resetRegulatoryInfo = () => {
    return (dispatch) => {
      dispatch(clearRegulatoryInfo());
    };
  }